import type { SVGProps } from 'react';

const SvgTranscoder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M7 11c.55 0 1-.45 1-1V6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1.59l-.29-.29a.996.996 0 1 0-1.41 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29l2-2a.996.996 0 1 0-1.41-1.41l-.29.29V6c0-1.65-1.35-3-3-3h-6c-1.65 0-3 1.35-3 3v4c0 .55.45 1 1 1zm3 2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1m-1 6H5v-4h4zm8-6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
    />
  </svg>
);
export default SvgTranscoder;
